// File: src/bridge/goalbuddy/emitAtomicRunsUpdate.ts
//
// GoalBuddy → OmniCine AtomicRuns bridge (emitter)
// ------------------------------------------------
// Emits via TimelineSurfaceEvents.emitAtomicRunsUpdate()
//
// detail: { sessionId, runs, source, note }
//
// source policy:
// - "system"    service hydration / store-driven
// - "ai-assist" model-generated runs
// - "user"      explicit user action
//

import {
  emitAtomicRunsUpdate as emitAtomicRunsUpdateEvent,
  type AtomicRunsUpdateDetail,
} from "@/contracts/omnicine/TimelineSurfaceEvents";

export type { AtomicRunsUpdateDetail };

export function emitAtomicRunsUpdate(detail: AtomicRunsUpdateDetail): void {
  try {
    emitAtomicRunsUpdateEvent(detail);
  } catch {
    // ignore
  }
}